import { ReactNode } from 'react';
import { StyledFeatureBox, StyledFeatureText } from './FeatureBox.styles';
import {
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';
import { FeatureStatus } from '@/hooks/useFeatures';

export interface FeatureBoxProps {
  children: ReactNode;
  status: FeatureStatus;
}

function FeatureBox({ children, status }: FeatureBoxProps) {
  return (
    <StyledFeatureBox status={status} data-testid="feature-box">
      <StyledFeatureText tag={TextTag.p} appearance={TokenTextAppearance.copy200} status={status}>
        {children}
      </StyledFeatureText>
    </StyledFeatureBox>
  );
}

export default FeatureBox;
